import { Howl } from 'howler'
import { ref } from 'vue'

// Drop sound files in webapp/public/sounds/ — they're served at /sounds/<name>.mp3.
// Howler handles AudioContext unlock automatically on first user interaction.

export const mutedRef = ref(false)
export const toggleMute = () => { mutedRef.value = !mutedRef.value }

function make(file: string, vol = 0.7) {
  return new Howl({ src: [`/sounds/${file}`], volume: vol })
}

const s = {
  expand:       make('maximize_008.ogg',    0.5),
  collapse:     make('minimize_008.ogg',    0.5),
  colorChange:  make('drop_003.ogg',       0.6),
  diceShake:    make('dice-shake-1.ogg',   0.7),
  dieThrow:     make('die-throw-1.ogg',    0.7),
  start:        make('jingles_PIZZI16.ogg', 0.75),
  placeCards:   make('card-fan-1.ogg',     0.6),
  switchA:      make('switch_001.ogg',     0.7),
  switchB:      make('switch_002.ogg',     0.7),
  cardReveal:   make('card-slide-2.ogg',   0.6),
  cardHide:     make('card-slide-5.ogg',   0.6),
  matchFail:    make('bong-001.mp3',       0.7),
  matchSucceed: make('jingles_PIZZI10.ogg', 0.75),
  matchCollect: make('glass-001.mp3',      0.6),
  gameOver:     make('jingles_PIZZI10.ogg', 0.8),
}

function play(howl: Howl) {
  if (!mutedRef.value) {
    howl.play()
  }
}

export const expand       = () => play(s.expand)
export const collapse     = () => play(s.collapse)
export const colorChange  = () => play(s.colorChange)
export const diceShake    = () => play(s.diceShake)
export const dieThrow     = () => play(s.dieThrow)
export const startGame    = () => play(s.start)
export const placeCards   = () => play(s.placeCards)
export const turnLanded   = (team: number) => play(team === 0 ? s.switchA : s.switchB)
export const cardReveal   = () => play(s.cardReveal)
export const cardHide     = () => play(s.cardHide)
export const matchFail    = () => play(s.matchFail)
export const matchSucceed = () => play(s.matchSucceed)
export const matchCollect = () => play(s.matchCollect)
export const gameOver     = () => play(s.gameOver)
